import React from "react";
import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import Collapsible, { ChevronContainer } from "components/ui/collapsible/Collapsible";
import UIcon from "lib/icons/untitled_ui/UIcon";

type ReportCollapseProps = {
  title: string;
  defaultOpen?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  actions?: React.ReactNode;
  children: React.ReactNode;
};

export default function ReportCollapse({
  title,
  defaultOpen = true,
  open,
  onOpenChange,
  actions = null,
  children,
}: ReportCollapseProps) {
  const [internalOpen, setInternalOpen] = React.useState(defaultOpen);
  const isControlled = open !== undefined;
  const isOpen = isControlled ? open : internalOpen;

  const handleOpenChange = (next: boolean) => {
    if (!isControlled) setInternalOpen(next);
    onOpenChange?.(next);
  };

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={handleOpenChange}
      title={
        <Flex gap={4} alignItems="center">
          <Text h3>{title}</Text>
          <ChevronContainer open={isOpen}>
            <UIcon icon="chevronDown" size={24} />
          </ChevronContainer>
        </Flex>
      }
      showChevron={false}
      dividerOnOpen={false}
      showBottomDivider={false}
      chevronContent={actions}
      headerTriggerProps={{ padding: "12px 16px", borderRadius: 8, minHeight: "auto" }}
      headerContentProps={{ padding: "0" }}
      contentWrapperStyles={{ padding: "8px 16px 16px" }}
    >
      {children}
    </Collapsible>
  );
}

export const CollapseGroup = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: 24,
});
